import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '../Icon';
import Tooltip from '../Tooltip';

const DashboardAreaBox = ({ color, disabled, icon, onClick, text, tooltip, transparent }) => {
  const modifierClasses = {
    [`dashboard-area-box--color-${color}`]: color,
    'dashboard-area-box--transparent': transparent,
  };
  if (onClick) {
    return (
      <div className={cx('dashboard-area-box', modifierClasses)}>
        <Tooltip tooltip={tooltip}>
          <span
            className={cx('dashboard-area-box__button-wrapper', {
              'dashboard-area-box__button-wrapper--disabled': disabled,
            })}
          >
            <button
              className="dashboard-area-box__button"
              disabled={disabled}
              onClick={onClick}
              type="button"
            >
              {icon && <Icon className="dashboard-area-box__icon" size="small" kind={icon} />}
              {!icon && <p className="dashboard-area-box__text">{text}</p>}
            </button>
          </span>
        </Tooltip>
      </div>
    );
  }
  return (
    <div className={cx('dashboard-area-box', modifierClasses)}>
      {icon && <Icon className="dashboard-area-box__icon" size="small" kind={icon} />}
      {!icon && <p className="dashboard-area-box__text">{text}</p>}
    </div>
  );
};

DashboardAreaBox.defaultProps = {
  text: '',
  icon: '',
  disabled: false,
  transparent: false,
};

DashboardAreaBox.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  color: PropTypes.string.isRequired,
  transparent: PropTypes.bool,
  tooltip: PropTypes.node,
};

export default DashboardAreaBox;
